import SEO from '../components/SEO';
import React from 'react';
import Navigation from '../components/Navigation';
import SiteFooter from '../components/SiteFooter';

export default function TermsPage() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <SEO title="Terms of Service" description="GetBenefitSavings terms of service and usage agreement." path="/terms" keywords="" />
      
      <Navigation />
      
      <section className="bg-gradient-hero py-20 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Terms of Service</h1>
          <p className="text-xl md:text-2xl opacity-90 max-w-2xl mx-auto">
            Terms and conditions for using our services
          </p>
        </div>
      </section>

      <section className="py-16 bg-white flex-grow">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">Last updated: February 15, 2026</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Acceptance of Terms</h2>
            <p className="text-gray-700 mb-4">
              By accessing and using GetBenefitSavings, you accept and agree to be bound by the terms and provisions of this agreement.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Use of Service</h2>
            <p className="text-gray-700 mb-4">
              Our service is provided for informational purposes only. We do not provide financial, legal, or professional advice. Always consult with qualified professionals for your specific situation.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">User Responsibilities</h2>
            <p className="text-gray-700 mb-4">
              You agree to use our service only for lawful purposes and in accordance with these Terms of Service.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Contact Us</h2>
            <p className="text-gray-700 mb-4">
              For questions about these Terms, contact us at legal [at] getbenefitsavings [dot] com
            </p>
          </div>
        </div>
      </section>

      
      <SiteFooter />
    </div>
  );
}
